import { fetchUtils } from 'react-admin';

const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5180/api';

function getHeaders() {
  const headers = new Headers({ Accept: 'application/json' });
  const authToken = localStorage.getItem('session') || localStorage.getItem('token');
  if (authToken) headers.set('Authorization', `Bearer ${authToken}`);
  return headers;
}

type RawUser = {
  id: string | number;
  userName?: string;
  name?: string;
  username?: string;
  email?: string;
  roleId?: string | number;
  role?: { id?: string | number; roleName?: string };
};

type RawRole = {
  id: string | number;
  roleName?: string;
  name?: string;
};

export type Approver = {
  id: string;
  name: string;
  role: string;
  email: string;
};

const normalizeList = (payload: any): any[] => {
  if (!payload) return [];
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload.data)) return payload.data;
  return [];
};

export async function fetchApprovers(): Promise<Approver[]> {
  const [usersResponse, rolesResponse] = await Promise.all([
    fetchUtils.fetchJson(`${apiUrl}/permissionUsers`, { headers: getHeaders() }),
    fetchUtils.fetchJson(`${apiUrl}/permissionRoles`, { headers: getHeaders() })
  ]);

  const users = normalizeList(usersResponse.json) as RawUser[];
  const roles = normalizeList(rolesResponse.json) as RawRole[];

  const roleMap = new Map<string | number, string>();
  roles.forEach(role => {
    const roleName = role.roleName || role.name || '';
    if (role.id != null) roleMap.set(role.id, roleName);
  });

  return users.map(user => {
    const roleName =
      roleMap.get(user.roleId ?? '') ||
      user.role?.roleName ||
      '';

    return {
      id: String(user.id ?? ''),
      name: user.userName || user.name || user.username || '',
      role: roleName || '-',
      email: user.email || ''
    };
  });
}
